// Global behaviours that used to come from Bootstrap's jQuery plugins.
//
// `import 'bootstrap/dist/js/bootstrap.min'` is gone: of the eleven plugins it
// shipped, this app only ever used modal, dropdown and one navbar collapse.
// Tooltips had already moved to v-tooltip (no Bootstrap tooltip calls
// remained); tab, popover, carousel, affix, scrollspy, button and alert had no
// call sites at all.
//
//   modal    -> src/js/modal.js, self-installing on first open
//   dropdown -> src/js/dropdown.js, delegated from document (below)
//   collapse -> Vue state in TopBar.vue, the only place it was used
//
// jQuery itself is still loaded, but only because Select2 needs it — see
// src/components/Select2.js and DESIGN_SYSTEM.md section 11.3.
import installDropdowns from './js/dropdown';

installDropdowns();
